import { useDispatch } from 'react-redux'
import MobileAppPopup from '../../components/MobileAppPopup/MobileAppPopup.js'
import WelcomePopup from '../../components/WelcomePopup/WelcomePopup.js'
import { gotoLogIn } from '../../redux/actions/AuthActions'
import { JoinColumn, JoinSection, JoinTitle } from './join.styles.js'
import { Button, Container, Show, Text, VerticalCenterContainer } from './landing.styles.js'

const Join = ({ title, description, postfix = '' }) => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }

  return (
    <>
      <JoinSection>
        <Container>
          <VerticalCenterContainer>
            <JoinColumn>
              <JoinTitle>
                {title}
                <span> DecorMatters </span>
                {postfix}
              </JoinTitle>
              <Show on="desktop">
                <Button onClick={openLogin}>Start Designing with 10M+ Users</Button>
              </Show>
            </JoinColumn>
            <Text>{description}</Text>
            <Show on="mobile">
              <Button onClick={openLogin}>Start Designing with 10M+ Users</Button>
            </Show>
          </VerticalCenterContainer>
        </Container>
      </JoinSection>
      <MobileAppPopup />
      <WelcomePopup />
    </>
  )
}

export default Join
